import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { dashboardAction } from "../../redux/action";
import { ROUTE } from "../../route/Route";
import BreadCrumb from "../breadcrumb/BreadCrumb";
import WaitScreen from "../LodingScreen/WaitScreen";
import SeoAdd from "../Seo/SeoAdd";
import SubmitForm from "../SubmitForm/SubmitForm";
import { useTranslation } from "react-i18next";
import { validateGeneralEnquiry } from "../../constant/validation";
import SectionLoader from "../LodingScreen/SectionLoader";

const CorporateOffice = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const details: any = useSelector(
    (state: any) => state.dashboard.generalDetails
  );

  useEffect(() => {
    window?.scrollTo(0, 0);
    dispatch(dashboardAction.generalDetailAction({}));
    return () => {};
  }, []);

  return (
    <>
      <SeoAdd slug={ROUTE.CORPORATEOFFICE} />
      <BreadCrumb page={t("office")} data={{ slug: "", path: "#" }} />
      <div style={{ position: "relative" }}>
        <div className="mapdiv"></div>
        <div className="colordiv"></div>
        <div className="zInd">
          <section className="corporate">
            <div className="container">
              <div className="row wd-corporate">
                <div className="col-12">
                  <div className="headingmains text-center pt-2">
                    {details && Object.keys(details)?.length > 0 ? (
                      <>
                        <h3 className="right aos-init pb-2">
                          {t("reg_office")}
                        </h3>
                        <p className="text-center py-2 text_light">
                          {t("company_name")}
                        </p>
                        <div className="text-center py-1">
                          {t(details?.RegisteredOfficeAddress)}
                        </div>
                        <h3 className="right aos-init pb-2 mt-3">
                          {t("laboratory_reference")}
                        </h3>
                        <p className="text-center py-2 text_light">
                          {t("company_name")}
                        </p>
                        <div className="text-center py-1">
                          {t(details?.OfficeAddress)}
                        </div>
                        <ul className="corporate_box">
                          {details?.PhoneNumber && (
                            <li>
                              <div>
                                <a
                                  className="text"
                                  target="_blank"
                                  href={`tel: ${details?.PhoneNumber}`}
                                >
                                  <img
                                    src="/assets/img/call.png"
                                    className="co_icon"
                                  />
                                </a>
                              </div>
                              <div>{t("phone_number")}</div>
                              <div>
                                <a
                                  className="text"
                                  target="_blank"
                                  href={`tel: ${details?.PhoneNumber}`}
                                >
                                  {details?.PhoneNumber}
                                </a>
                              </div>
                            </li>
                          )}
                          {details?.EmailId && (
                            <li>
                              <div>
                                <a
                                  className="text"
                                  href={`mailto: ${details?.EmailId}`}
                                >
                                  <img
                                    src="/assets/img/email.png"
                                    className="co_icon"
                                  />
                                </a>
                              </div>
                              <div>{t("email")}</div>
                              <div>
                                <a
                                  className="text"
                                  href={`mailto: ${details?.EmailId}`}
                                >
                                  {details?.EmailId}
                                </a>
                              </div>
                            </li>
                          )}
                          {details?.WhatsApp && (
                            <li>
                              <div>
                                <a
                                  href={`https://wa.me/+91${details?.WhatsApp}`}
                                  target="_blank"
                                >
                                  <img
                                    src="/assets/img/whatsapp.png"
                                    className="co_icon"
                                  />{" "}
                                </a>
                              </div>
                              <div>{t("whatsApp")}</div>
                              <div>
                                <a
                                  href={`https://wa.me/+91${details?.WhatsApp}`}
                                  target="_blank"
                                >
                                  {details?.WhatsApp}{" "}
                                </a>
                              </div>
                            </li>
                          )}
                        </ul>
                        <div className="text-center mt-3">
                          <span className="customer_care">
                            {t("customer_care")}{" "}
                            <a
                              target="_blank"
                              href={`tel: ${details?.CustomerCare}`}
                            >
                              {details?.CustomerCare}
                            </a>
                          </span>
                        </div>
                      </>
                    ) : (
                      <SectionLoader />
                    )}
                  </div>
                    <SubmitForm
                      heading={t("enquiry")}
                      des={t("neurology_form_note")}
                      PageSrc={"Corporate Office"}
                      validationSchema={validateGeneralEnquiry}
                    />
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default CorporateOffice;
